import { MainHeaderProps } from "@/common/types";
import PageName from "./PageName";
import UserInfo from "./UserInfo";

export default function MainHeader({ pageName, children }: MainHeaderProps) {
  return (
    <div className="flex justify-between items-center p-5  w-full">
      <div className="w-4/5 flex justify-between bg-white rounded-full px-[22px] py-3 items-center">
        <PageName pageName={pageName} />
        {typeof children === "undefined" ? "" : children}
      </div>
      <UserInfo />
    </div>
  );
}
